/** A game's show page: its details and configurations. */
export function gameShowPath(gameId: string) {
  return `/platform/games/${gameId}`
}

/**
 * A configuration's page: its draft and editor, save history, simulations
 * and test seeds.
 */
export function configurationPath(gameId: string, configurationId: string) {
  return `${gameShowPath(gameId)}/configurations/${configurationId}`
}

/**
 * A version as staff read it: the name of its configuration and its number
 * there (`Default configuration · v2`). A version number counts the
 * publishes of one configuration, so it is never shown without the name.
 */
export function versionLabel(configurationName: string, version: number) {
  return `${configurationName} · v${version}`
}
